import { getAuthServiceConfig } from './auth-service'
import ProductEnum from './services/enums/ProductEnum'

export function goToCustomerPortal(path: string) {
  const auth = getAuthServiceConfig()
  if (auth.enabled && auth.token) {
    auth.handOffSessionToNewCustomerPortal(path)
    return
  }
  window.location.assign(new URL(path, getCustomerPortalUrl()))
}

export function getCustomerPortalUrl() {
  return window.injectedEnv.FRONTEND_NEW_CUSTOMER_PORTAL_URL
}

export function goToCustomerPortalJourneyForProduct(product: ProductEnum, transactionType: 'nb', query?: Record<string, string>) {
  let newCustomerPortalPath = `/journey/${transformProduct(product)}/${transactionType}`

  if (query && Object.keys(query).length > 0) {
    const searchParams = new URLSearchParams()
    Object.entries(query).forEach(([key, value]) => {
      searchParams.append(key, value)
    })
    const queryString = searchParams.toString()
    if (queryString) {
      newCustomerPortalPath += `?${queryString}`
    }
  }

  goToCustomerPortal(newCustomerPortalPath)
}

export function goToCustomerPortalNBResumeQuotePage(product: ProductEnum, quoteReference: string, page: string) {
  const newCustomerPortalPath = `/journey/${transformProduct(product)}/nb/${page}?quoteReference=${quoteReference}`
  goToCustomerPortal(newCustomerPortalPath)
}

export function transformProduct(product: ProductEnum) {
  switch (product) {
    case ProductEnum.modernCar:
      return 'modern-car'
    case ProductEnum.multiPet:
      return 'multi-pet'
    case ProductEnum.home:
      return 'home'
    case ProductEnum.vehicle:
      return 'vehicle'
    case ProductEnum.commercialVehicle:
      return 'commercial-vehicle'
    default:
      throw new Error(`customer-portal: could not transform product ${product}`)
  }
}
